module.exports = {
	individualData: () => {
		return [
			{
				'MUSTANG AUTOMÓVILES': [
					{
						Nombre: 'MUSTANG GT PREMIUM',
						Imagen: require('./../UI/canvas/sidebar/carros/Mustang GT Premium.webp'),
					},
					{
						Nombre: 'MUSTANG MACH 1',
						Imagen: require('./../UI/canvas/sidebar/carros/Mustang Mach 1.webp'),
					},
				],
				'ESCAPE CAMIONETAS': [
					{
						Nombre: 'ESCAPE ECOBOOST',
						Imagen: require('./../UI/canvas/sidebar/carros/Escape Ecoboost.webp'),
					},
					{
						Nombre: 'ESCAPE SE 4X2 FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/Escape SE 4x2 HEV.webp'),
					},
					{
						Nombre: 'ESCAPE SEL 4X2 FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/Escape SEL 4x2 HEV.webp'),
					},
					{
						Nombre: 'ESCAPE TITANIUM 4X4 FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/Escape Hibrida.webp'),
					},
				],
				'BRONCO SPORT CAMIONETAS': [
					{
						Nombre: 'BRONCO SPORT WILDTRAK',
						Imagen: require('./../UI/canvas/sidebar/carros/Bronco Sport BB.webp'),
					},
					{
						Nombre: 'BRONCO SPORT BIG BEND',
						Imagen: require('./../UI/canvas/sidebar/carros/Bronco Sport WT.webp'),
					},
					/*{
						Nombre: 'BRONCO SPORT OUTER BANKS',
						Imagen: require('./../UI/canvas/sidebar/carros/Bronco_BD.webp'),
					},*/
				],
				'EDGE CAMIONETAS': [
					{
						Nombre: 'EDGE SEL',
						Imagen: require('./../UI/canvas/sidebar/carros/Edge SEL.webp'),
					},
					{
						Nombre: 'EDGE ST',
						Imagen: require('./../UI/canvas/sidebar/carros/Edge ST.webp'),
					},
				],
				'EXPLORER CAMIONETAS': [
					{
						Nombre: 'EXPLORER XLT',
						Imagen: require('./../UI/canvas/sidebar/carros/Explorer XLT.webp'),
					},
					{
						Nombre: 'EXPLORER LIMITED',
						Imagen: require('./../UI/canvas/sidebar/carros/Explorer Limited.webp'),
					},
					{
						Nombre: 'EXPLORER ST',
						Imagen: require('./../UI/canvas/sidebar/carros/Explorer ST.webp'),
					},
				],
				'EXPEDITION CAMIONETAS': [
					{
						Nombre: 'EXPEDITION LIMITED',
						Imagen: require('./../UI/canvas/sidebar/carros/Expedition Limited.webp'),
					},
				],
				'RANGER PICK-UPS': [
					{
						Nombre: 'RANGER XL',
						Imagen: require('./../UI/canvas/sidebar/carros/Ranger XL.webp'),
					},
					{
						Nombre: 'RANGER XLS DIESEL',
						Imagen: require('./../UI/canvas/sidebar/carros/Ranger XLS Diesel.webp'),
					},
					{
						Nombre: 'RANGER XL CHASIS',
						Imagen: require('./../UI/canvas/sidebar/carros/15_Ranger XL Chasis.webp'),
					},
					{
						Nombre: 'RANGER XLT',
						Imagen: require('./../UI/canvas/sidebar/carros/18_Ranger XLT.webp'),
					},
					{
						Nombre: 'RANGER LIMITED',
						Imagen: require('./../UI/canvas/sidebar/carros/16_Ranger Limited.webp'),
					},
					{
						Nombre: 'RANGER FX4',
						Imagen: require('./../UI/canvas/sidebar/carros/25_Ranger Fx4.webp'),
					},
					{
						Nombre: 'RANGER LIMITED BLACK EDITION',
						Imagen: require('./../UI/canvas/sidebar/carros/26_Ranger Limited Black.webp'),
					},
				],
				'F-150 PICK-UPS': [
					{
						Nombre: 'F-150 LARIAT SPORT',
						Imagen: require('./../UI/canvas/sidebar/carros/F-150 Lariat Sport.webp'),
					},
					{
						Nombre: 'F-150 XLT FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/F-150 XLT.webp'),
					},
					{
						Nombre: 'F-150 PLATINUM FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/F-150PlatinumFHEV.webp'),
					},
				],
				'RANGER RAPTOR PICK-UPS': [
					{
						Nombre: 'RANGER RAPTOR',
						Imagen: require('./../UI/canvas/sidebar/carros/Ranger Raptor.webp'),
					},
				],
				'F-150 RAPTOR PICK-UPS': [
					{
						Nombre: 'F-150 RAPTOR',
						Imagen: require('./../UI/canvas/sidebar/carros/F-150 Raptor.webp'),
					},
				],
				'MUSTANG PERFORMANCE': [
					{
						Nombre: 'MUSTANG MACH 1',
						Imagen: require('./../UI/canvas/sidebar/carros/Mustang Mach 1.webp'),
					},
				],
				'EDGE PERFORMANCE': [
					{
						Nombre: 'EDGE ST',
						Imagen: require('./../UI/canvas/sidebar/carros/Edge ST.webp'),
					},
				],
				'EXPLORER PERFORMANCE': [
					{
						Nombre: 'EXPLORER ST',
						Imagen: require('./../UI/canvas/sidebar/carros/Explorer ST.webp'),
					},
				],
				'RANGER PERFORMANCE': [
					{
						Nombre: 'RANGER RAPTOR',
						Imagen: require('./../UI/canvas/sidebar/carros/Ranger Raptor.webp'),
					},
				],
				'F-150 PERFORMANCE': [
					{
						Nombre: 'F-150 RAPTOR',
						Imagen: require('./../UI/canvas/sidebar/carros/F-150 Raptor.webp'),
					},
				],
				'F-150 HÍBRIDOS': [
					{
						Nombre: 'F-150 PLATINUM FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/F-150 Raptor.webp'),
					},
				],
				'ESCAPE HÍBRIDOS': [
					{
						Nombre: 'ESCAPE TITANIUM 4X4 FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/Escape Hibrida.webp'),
					},
					{
						Nombre: 'ESCAPE SE 4X2 FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/Escape SE 4x2 HEV.webp'),
					},
					{
						Nombre: 'ESCAPE SEL 4X2 FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/Escape SEL 4x2 HEV.webp'),
					},
				],
			},
		];
	},
};
